import { HStack, Link, useTheme } from '@chakra-ui/react';
import React, { useState } from 'react';
import InstagramSvg from '../../svgComponents/instagram/Instagram';
import LinkedinSvg from '../../svgComponents/linkedin/Linkedin';
import EmailSvg from '../../svgComponents/email/email';
import FacebookSvg from '../../svgComponents/facebook/Facebook';
import { FaGraduationCap } from 'react-icons/fa'; // Asegúrate de tener react-icons instalado


const resetMediaHover = {
  email: false,
  facebook: false,
  instagram: false,
  linkedin: false,
  campus: false, // Nuevo estado para el campus

}

export default function SocialMedia({ customStyles={} }) {
  const [activeHover, setActiveHover] = useState(resetMediaHover);
  const theme = useTheme();
  const style = styles(theme, customStyles, activeHover);

  const circleColor = customStyles?.circleColor || theme.background.primary;
  const activeHoverColor = theme.background.tertiary;
  
  const handleMediaActive = (tag) => {    
    setActiveHover({
     ...resetMediaHover,
      [tag]: true
    })
  }

  return (
    <HStack spacing={4} style={style.container}>
      <Link
        href="mailto:gestar@gestareducativa.com.ar"
        isExternal
        onMouseOver={() => handleMediaActive("email")}
        onMouseLeave={() => setActiveHover(resetMediaHover)}
      >
        <EmailSvg
          size={30}
          fillCircle={activeHover.email ? activeHoverColor : circleColor}
        />
      </Link>
      <Link
        href="https://www.facebook.com/gestargrupoeducativo/"
        isExternal
        onMouseOver={() => handleMediaActive("facebook")}
        onMouseLeave={() => setActiveHover(resetMediaHover)}
      >
        <FacebookSvg
          size={30}
          fillCircle={activeHover.facebook ? activeHoverColor : circleColor}
        />
      </Link>
      <Link href="https://www.instagram.com/gestareducativa/" isExternal>
        <div
          style={style.instagramCircle}
          href="https://www.instagram.com"
          isExternal
          onMouseOver={() => handleMediaActive("instagram")}
          onMouseLeave={() => setActiveHover(resetMediaHover)}
        >
          <InstagramSvg size={20} />
        </div>
      </Link>
      <Link
        href="https://www.linkedin.com/company/89852378/"
        isExternal
        onMouseOver={() => handleMediaActive("linkedin")}
        onMouseLeave={() => setActiveHover(resetMediaHover)}
      >
        <LinkedinSvg
          size={30}
          fillCircle={activeHover.linkedin ? activeHoverColor : circleColor}
        />
      </Link>
      <Link
        href="https://campusgestar.com/"
        isExternal
        onMouseOver={() => handleMediaActive("campus")}
        onMouseLeave={() => setActiveHover(resetMediaHover)}
      >
        <div
          style={{
            padding: '0.3rem',
            borderRadius: 40,
            backgroundColor: activeHover.campus ? activeHoverColor : circleColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <FaGraduationCap size={20} color="#fff" />
        </div>
      </Link>
    </HStack>
  );
}

const styles = (theme, customStyle, activeHover) => ({
  container: {
    ...customStyle.container
  },
  instagramCircle:{
    padding: '0.3rem',
    borderRadius: 40,
    backgroundColor: activeHover.instagram? theme.background.tertiary : (customStyle?.circleColor || theme.background.primary),
    ...customStyle.instagramCircle
  }
});
